export default __webpack_public_path__ + "static/media/typography.48020adf.png";